"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedStreemshotCamera = exports.AnimatedImage = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const keyframes_1 = require("../../styles/keyframes");
const styled_1 = __importDefault(require("../../styles/styled"));
const layout_1 = require("../layout");
const icons_1 = require("../icons");
const styles_1 = require("../../styles");
const AnimatedImage = props => {
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({ animationDuration: props.animationDuration, src: props.src }, { children: (0, jsx_runtime_1.jsx)(ImageContainer, { src: props.src }) })));
};
exports.AnimatedImage = AnimatedImage;
const AnimatedStreemshotCamera = props => {
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({ animationDuration: props.animationDuration, src: '' }, { children: (0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: "StreemshotCamera" }) })));
};
exports.AnimatedStreemshotCamera = AnimatedStreemshotCamera;
const Container = (0, styled_1.default)(layout_1.Box)((props) => ({
    animation: props.src
        ? `${keyframes_1.animationKeyframes.scaleToNothing} ${props.animationDuration}ms ease`
        : `${keyframes_1.animationKeyframes.fadeOut} ${props.animationDuration}ms ease`,
    animationFillMode: 'forwards',
    transformOrigin: 'bottom left',
    background: !props.src && styles_1.Theme.colors.whiteA50,
}), {
    display: 'flex',
    height: '100%',
    position: 'absolute',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    zIndex: 3,
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
});
const ImageContainer = styled_1.default.img({
    pointerEvents: 'none',
    objectFit: 'contain',
    height: '100%',
    maxWidth: '100%',
});
//# sourceMappingURL=animated_image.js.map